import { useLocation, useNavigate } from "react-router";

import { MessageSquareIcon } from "lucide-react";

import { Icon } from "simplydo/react/ui/icon";

import { TooltipButton } from "components/lib/UI";

import type { IdeaWithOwnerChallenge } from "../types";

type ScrollToCommentsActionProps = { idea: IdeaWithOwnerChallenge };

const ScrollToCommentsAction = ({ idea }: ScrollToCommentsActionProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (idea?.ownerChallenge?.preventIdeaComments) {
    return null;
  }

  return (
    <TooltipButton
      tooltip={"Scroll to comments"}
      style={{ position: "relative" }}
      className="is-icon"
      onClick={() => {
        navigate(location.search + "#comments");
      }}
    >
      <Icon icon={MessageSquareIcon} />
      {idea.commentCount ? (
        <div
          style={{
            position: "absolute",
            right: 3,
            bottom: 0,
            opacity: 0.9,
            fontSize: 10,
          }}
        >
          {idea.commentCount || 0}
        </div>
      ) : null}
    </TooltipButton>
  );
};

export default ScrollToCommentsAction;
